<template>
  <layout :session="session" :participant="participant">
    <div class="mt-12 sm:mt-0 px-4 py-5 text-center">
      <div
        class="min-w-0 flex-1 h-full max-w-sm mx-auto lg:order-last px-3 select-none"
      >
        <img src="/img/participate.png" class="w-3/5 sm:w-4/5 mx-auto my-12" />
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/Pages/Live/Shared/Layout';

export default {
  components: {
    Layout
  },

  props: ['session', 'participant', 'translations'],

  data() {
    return {
      sending: false
    };
  },

  methods: {}
};
</script>